<div class="root">
  <div class="filter-bar">
    <div>
      <div>{{ 'label.InvoiceCode' | translate }}</div>
      <div>
        <input
          type="text"
          [(ngModel)]="filterPagingWrapper.filter.invoiceCode"
        />
      </div>
    </div>
    <div>
      <div>{{ 'label.CustomerCredential' | translate }}</div>
      <div>
        <input
          type="text"
          [(ngModel)]="filterPagingWrapper.filter.customerCredential"
        />
      </div>
    </div>
    <div class="c-date-picker">
      <div>{{ 'label.Dates' | translate }}:</div>
      <hr-date-range-picker
        class="date-picker"
        [dateFormat]="specialDateFormat"
        [style]="{ width: '100%', 'min-width': '5em' }"
        [(ngModel)]="filterPagingWrapper.filter.paymentDate"
      ></hr-date-range-picker>
    </div>
    <br />
    <div>
      <p-checkbox
        [(ngModel)]="filterPagingWrapper.filter.displayOnlyPositiveAmount"
        inputId="chk-displayOnlyPositiveAmount"
        binary="true"
      ></p-checkbox>
      <label for="chk-displayOnlyPositiveAmount">{{
        'label.DisplayOnlyPositiveAmount' | translate
      }}</label>
      <br />
    </div>
    <br />
    <div>
      <button class="apply" (click)="onApplyFilter()">
        {{ 'label.Filter' | translate }}
      </button>
      <button class="clear" (click)="onClearFilter()">
        {{ 'label.Clear' | translate }}
      </button>
    </div>
  </div>
  <div class="payments-table">
    <hr-edit-payment
      [mode]="paymentAddMode"
      (onHide)="onFinishAddPayment()"
      [payment]="editingPayment"
    ></hr-edit-payment>
    <div style="padding-bottom: 5px">
      <button
        [disabled]="!hasPaymentsManagementPermission"
        (click)="onAddNewPayment()"
      >
        {{ 'label.AddNewPayment' | translate }}
      </button>
    </div>
    <p-table
      [value]="payments"
      [lazy]="true"
      showGridlines
      [paginator]="true"
      [rows]="pageSize"
      (onLazyLoad)="onLoad($event)"
      [totalRecords]="totalRecords"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 38px">&nbsp;</th>

          <th [pSortableColumn]="'paymentCode'">
            {{ 'label.PaymentCode' | translate }}
            <p-sortIcon
              [field]="'paymentCode'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'paymentDate'" style="width: 110px">
            {{ 'label.Date' | translate }}
            <p-sortIcon
              [field]="'paymentDate'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'customer'" style="width: 220px">
            {{ 'label.Payer' | translate }}
            <p-sortIcon
              [field]="'customer'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'paymentTotal'" style="width: 100px">
            {{ 'label.PaymentAmount' | translate }}
            <p-sortIcon
              [field]="'paymentTotal'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'amountLeft'" style="width: 100px">
            {{ 'label.AmountLeft' | translate }}
            <p-sortIcon
              [field]="'amountLeft'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th>
            {{ 'label.Invoices' | translate }}
          </th>
          <th>
            {{ 'label.Comment' | translate }}
          </th>

          <th [pSortableColumn]="'createUser'">
            {{ 'label.User' | translate }}
            <p-sortIcon
              [field]="'createUser'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
          <th style="width: 90px">&nbsp;</th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-payment
        let-expanded="expanded"
        let-columns="columns"
      >
        <tr>
          <td>&nbsp;</td>
          <td>
            <span>{{ payment.paymentCode }}</span>
          </td>
          <td>
            <span>{{ payment.paymentDate | date : dateFormat }}</span>
          </td>
          <td>
            <span
              ><a [routerLink]="['/customers/view', payment?.customerId]">{{
                payment.payerName
              }}</a></span
            ><br />
            <span>{{ payment.payerTaxId }}</span>
          </td>
          <td>
            <span>{{ payment.amount }}</span>
          </td>
          <td>
            <span>{{ payment.amountLeft }}</span>
          </td>

          <td>
            <a
              *ngFor="let code of payment.invoiceCodes"
              [routerLink]="['/billing/invoices/list', code]"
              >{{ code }}
            </a>
          </td>
          <td>
            <span>{{ payment.comment }}</span>
          </td>
          <td>
            <span>{{ payment.createUserName }}</span>
          </td>
          <td>
            <div class="delete-buttons">
              <p-button
                type="button"
                (click)="onPaymentDelete(payment)"
                icon="fa fa-times-circle"
              ></p-button>
              <p-button
                type="button"
                [disabled]="!hasPaymentsManagementPermission"
                (click)="onEditPaymentClick(payment)"
                icon="fa fa-edit"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer" let-columns>
        <tr>
          <td>{{ totalRecords }}</td>
          <td colspan="3"></td>
          <td>{{ totalAmounts?.totalAmount }}</td>
          <td>{{ totalAmounts?.amountLeft }}</td>
          <td colspan="4"></td>
        </tr>
      </ng-template>

      <!-- <p-column [style]="{'width':'38px'}"></p-column>
            <p-column header="{{'label.PaymentCode' | translate}}" field="paymentCode" [sortable]="true">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span>{{payment.paymentCode}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Date' | translate}}" field="paymentDate" [sortable]="true">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span>{{payment.paymentDate | date:dateFormat}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Payer' | translate}}" field="customer" [sortable]="true">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span><a [routerLink]="['/customers/view', payment?.customerId]">{{payment.payerName}}</a></span><br>
                <span>{{payment.payerTaxId}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.PaymentAmount' | translate}}" field="paymentTotal" [sortable]="true">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span>{{payment.amount}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.AmountLeft' | translate}}" field="amountLeft" [sortable]="true">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span>{{payment.amountLeft}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Invoices' | translate}}">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <a *ngFor="let code of payment.invoiceCodes" [routerLink]="['/billing/invoices/list', code]">{{code}} </a>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Comment' | translate}}">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span>{{payment.comment}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.User' | translate}}" field="createUser" [sortable]="true">
            <ng-template let-col let-payment="rowData" pTemplate="body">
                <span>{{payment.createUserName}}</span>
            </ng-template>
            </p-column>
            <p-column [style]="{'width':'64px'}">
                <ng-template let-col let-payment="rowData" pTemplate="body">
                <p-button type="button" (click)="onPaymentDelete(payment)" style="float: left;" icon="fa fa-times-circle"></p-button>
                <p-button type="button" [disabled]="!hasPaymentsManagementPermission" (click)="onEditPaymentClick(payment)" style="float: right;" icon="fa fa-edit"></p-button>
            </ng-template>
            </p-column>
            <p-footerColumnGroup>
                <p-row>
                    <p-column footer="{{totalRecords}}"></p-column>
                    <p-column colspan="3"></p-column>
                    <p-column footer="{{totalAmounts?.totalAmount}}"></p-column>
                    <p-column footer="{{totalAmounts?.amountLeft}}"></p-column>
                    <p-column colspan="4"></p-column>
                </p-row>
            </p-footerColumnGroup> -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="10">
            {{ 'message.NoRecordsFound' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
